<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 17:07:08
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <h3 class="myTit clearfix">
      <span>我的评价</span>
      <ul class="clearfix noselect" v-if="false">
        <li :class="{active:titIndex === 0}" @click="titChange(0)">办理中</li>
        <li :class="{active:titIndex === 1}" @click="titChange(1)">已经办结</li>
      </ul>
    </h3>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="事项名称" prop="guidelineName">
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineSuggestionSuggestion" label="评价内容" align="center">
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineSuggestionSatisfaction" label="评价星级" width="180" align="center">
        <template slot-scope="scope">
          <el-rate v-model="scope.row.pcHandlingGuidelineSuggestionSatisfaction" disabled>
          </el-rate>
        </template>
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineSuggestionTime" label="评价时间" width="160" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block fenyeBox">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
        :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-dialog title="评价详情" :visible.sync="dialogVisible" width="550px" class="dialog">
      <div style="padding:0 15px;font-size:16px" class="dialog">
        <p><span>评价分数：</span>
          <el-rate v-model="pjScore" disabled show-text :texts="texts"
            style="display:inline-block">
          </el-rate>
        </p>
        <p><span>评价内容：</span>{{pjContent}}</p>
        <p><span>评价人：</span>{{pjPerson}}</p>
        <p><span>评价时间：</span>{{pjTime}}</p>
      </div>
<div slot="footer" class="dialog-footer">
  <el-button @click="dialogVisible = false">关闭</el-button>
</div>
    </el-dialog>

  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        tableData: [],
        value: 4.7,
        pageSize: 10,
        totalNum: 0,
        dialogVisible: false,
        currentPage4: 1,
        pjContent: '',
        pjTime: '',
        pjPerson: '',
        pjScore: 5,
        texts:['非常不满','不满','一般','满意','非常满意'],
      }
    },
    mounted() {
      this.getPj()
    },
    methods: {
      handleEdit(index, row) {
        this.pjContent = row.pcHandlingGuidelineSuggestionSuggestion,
          this.pjTime = row.pcHandlingGuidelineSuggestionTime,
          this.pjPerson = row.memberNickname,
          this.pjScore = row.pcHandlingGuidelineSuggestionSatisfaction,
          this.dialogVisible = true
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getPj()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage4 = val
        this.getPj()
      },
      titChange(idx) {
        this.titIndex = idx
      },
      getPj() {
        let sendData = qs.stringify({
          flag: true,
          pageNum: this.currentPage4,
          pageSize: this.pageSize,
          // memberId: this.$store.state.userId
        })
        this.ywtbRequest('/portal-ywtb/web/guidelineSuggestion/findSuggestion', sendData).then(res => {
          var data = res.dataList
          for (let i = 0; i < data.length; i++) {
            data[i].xuhao = i + 1;
            data[i].pcHandlingGuidelineSuggestionTime = this.publicJs.renderTime(data[i]
              .pcHandlingGuidelineSuggestionTime);
          }
          this.tableData = res.dataList;
          this.totalNum = res.count;
        })
      }
    }
  }

</script>

<style scoped>
  .myTit {
    /* line-height: 42px; */
    padding: 30px 0 15px 0;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .myTit>span {
    float: left;
    color: #091B28;
    font-size: 22px;
    font-family: PingFang SC;
  }

  .myTit>ul {
    float: right;
  }

  .myTit>ul>li {
    float: left;
    width: 84px;
    height: 34px;
    background: rgba(53, 139, 247, 0.1);
    color: #687986;
    line-height: 34px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
  }

  .myTit>ul>li.active {
    background-color: #358BF7;
    color: #fff;
  }

  .detailBtn,
  .advisoryBtn {
    width: 56px;
    height: 27px;
    border-radius: 14px;
    padding: 0;
    text-align: center;
    font-size: 13px;
    color: #fff;
    border: none;
  }

  .detailBtn {
    background: rgba(255, 165, 71, 1);

  }

  .detailBtn:hover, .detailBtn:focus {
    background: rgba(255, 165, 71, 0.8);
    color: #fff;
  }

  .advisoryBtn {
    background: rgba(53, 139, 247, 1);
  }

  .advisoryBtn:hover, .advisoryBtn:focus {
    background: rgba(53, 139, 247, 0.8);
    color: #fff;
  }

  .fenyeBox {
    text-align: center;
    padding-top: 20px;
  }

  .newBg {
    display: inline-block;
    width: 55px;
    height: 23px;
    line-height: 22px;
    background: url(../../../../static/images/newBg.png) no-repeat 0px 0px;
    text-align: center;
    color: #fff;
    margin-left: 6px;
  }

  .dialog p {
    line-height: 36px;
    font-size: 14px;
  }
  .dialog p >span {
    display: inline-block;
    width: 70px;
    text-align: right;
    color: #999;
    color: #8C8C8C;
  }
  .dialog /deep/ .el-rate__icon {
    font-size: 24px;
  }

  .dialog /deep/ .el-dialog__title {
    color: #262626;
    font-size: 18px;
    font-weight: 700;
  }

  .dialog /deep/ .el-textarea__inner {
    resize: none;
  }

  .dialog /deep/ .el-dialog__body {
    padding: 25px 40px 5px 30px;
  }

  .dialog /deep/ .el-dialog__footer {
    text-align: center;
    padding: 15px 0 30px 0;
  }

  .dialog /deep/ .el-button {
    border-radius: 2px;
  }

  .dialog .tjBtn {
    background: rgba(68, 110, 255, 1);
    color: #fff;
    border: none;
  }

  .dialog .tjBtn:hover {
    background: rgb(50, 93, 250);
  }

</style>



// WEBPACK FOOTER //
// src/components/page/user/MyComment.vue